import { render, staticRenderFns } from "./Surowce.vue?vue&type=template&id=694099de&"
import script from "./Surowce.vue?vue&type=script&lang=js&"
export * from "./Surowce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports